import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { dismissDashboardCard, getDashboardCards, getSideLinks } from "./fetch";
import { dashboardCardsKeys } from "./keys";

export const useGetDashboardCards = () => {
  return useQuery({
    queryKey: dashboardCardsKeys.cards(),
    queryFn: getDashboardCards,
  });
};

// // useDismissDashboardCard with optimistic updates and rollback
export const useDismissDashboardCard = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (cardID) => dismissDashboardCard(cardID),
    onMutate: async (cardID) => {
      await queryClient.cancelQueries(dashboardCardsKeys.cards());

      const previousCards = queryClient.getQueryData(
        dashboardCardsKeys.cards()
      );

      const newCards = previousCards.cards.filter((card) => card.ID !== cardID);

      queryClient.setQueryData(dashboardCardsKeys.cards(), { cards: newCards });

      return { previousCards };
    },
    onError: (err, variables, context) => {
      queryClient.setQueryData(
        dashboardCardsKeys.cards(),
        context.previousCards
      );
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: dashboardCardsKeys.all(),
      });
    },
  });
};

export const useGetSideLinks = () => {
  return useQuery({
    queryKey: dashboardCardsKeys.sideLinks(),
    queryFn: getSideLinks,
  });
};
